import React from "react";
import { Line } from "react-chartjs-2";
import {
  Chart as ChartJS, CategoryScale, LinearScale, PointElement, LineElement, Tooltip, Legend, Filler,
} from "chart.js";

ChartJS.register(CategoryScale, LinearScale, PointElement, LineElement, Tooltip, Legend, Filler);

export default function EnrollmentOverviewChart({ data }) {
  const labels = data?.labels || ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
  const series = data?.series || [];

  const chartData = {
    labels,
    datasets: series.map((s, i) => ({
      label: s.name,
      data: s.data,
      borderColor: i === 0 ? "#7c3aed" : "#cbd5e1",
      backgroundColor: i === 0 ? "rgba(124,58,237,0.12)" : "rgba(203,213,225,0.1)",
      fill: true,
      tension: 0.4,
      pointRadius: 3,
    })),
  };

  return (
    <div style={{ height: "100%", minHeight: 200, width: "100%" }}>
      <Line
        data={chartData}
        options={{
          responsive: true,
          maintainAspectRatio: false,
          plugins: { legend: { position: "top", align: "start", labels: { boxWidth: 10, usePointStyle: true, color: "#111827" } } },
          scales: {
            y: { beginAtZero: true, grid: { color: "#f1f5f9" }, ticks: { color: "#374151" } },
            x: { grid: { display: false }, ticks: { color: "#374151" } },
          },
        }}
      />
    </div>
  );
}
